import { Stack, Typography } from "@mui/material";
import { BarChart } from "components/Dashboard/BarChart";
import ChartLegend from "components/Dashboard/ChartLegend";
import { WasteShipmentChartsQuery } from "generated-graphql/graphql";
import { useMemo } from "react";
import { formatNumber } from "util/formatNumber";
import { PriorityChartColorsPurple } from "util/insights";

export interface HighestGeneratingWasteStreamsGraphProps {
  data: NonNullable<
    WasteShipmentChartsQuery["facilityWasteShipmentCharts"]
  >["highestGeneratingWasteStreams"];
}

export const HighestGeneratingWasteStreamsGraph = ({
  data,
}: HighestGeneratingWasteStreamsGraphProps) => {
  const dataset = useMemo(() => {
    return (
      data?.map((stream) => ({
        name: stream.wasteStream?.name ?? "",
        amount: stream.amount,
      })) ?? []
    );
  }, [data]);

  return (
    <>
      <Stack direction="row" alignItems="center">
        <Typography variant="subtitle1">Highest generating waste streams in lbs</Typography>
      </Stack>
      <Stack display="flex" direction="row" height="100%">
        <BarChart
          dataset={dataset.length ? dataset : [{ amount: 0, label: "No data" }]}
          series={[
            {
              type: "bar",
              dataKey: "amount",
              valueFormatter: (value) => ` ${formatNumber(value)} lbs`,
            },
          ]}
          xAxis={[
            {
              scaleType: "band",
              dataKey: "name",
              categoryGapRatio: 0.4,
              colorMap: {
                type: "ordinal",
                colors: PriorityChartColorsPurple,
              },
            },
          ]}
          yAxis={[{ scaleType: "linear" }]}
          indexAxisLabelProperty={dataset.length ? "name" : undefined}
        />
        <ChartLegend
          items={dataset.map((d, index) => ({
            color: PriorityChartColorsPurple[index],
            value: `${index + 1}. ${d.name}`,
          }))}
          sx={{ flex: 1, maxWidth: "35%" }}
        />
      </Stack>
    </>
  );
};
